import React, {Component} from 'react'
import {VmPicker, VmView} from 'components'
import VmIndexRead from 'components/template/VmIndexRead'
import axios from 'axios'
import QueryString from 'qs'
import AlertYesNo from 'components/AlertYesNo'
import AlertOk from 'components/AlertOk'
import {Navigate, useSearchParams} from 'react-router-dom'
import {VmCheckIcon} from 'components/icons/solid'
import {ModalTambahObatKFA} from './modal-tambah-obat'

class Page extends Component {
  fields = [
    {
      key: 'obatnama',
      _style: {fontWeight: 'bold'},
      className: 'text-zinc-600 pb-2 border-blue-500 border-b-2 pt-6',
      // containerClassName: '',
    },
  ]

  fieldsDesktop = [
    {
      key: 'obatkode',
      label: 'Kode Obat',
      _style: {fontWeight: 'bold'},
      className: 'text-[#3B82F6] mt-6',
      sorter: true,
    },
    {
      key: 'obatnama',
      label: 'Nama Obat',
      _style: {fontWeight: 'bold'},
      className: 'text-[#3B82F6] mt-6',
      sorter: true,
    },
    {
      key: 'obatkandungan',
      label: 'Kandungan',
      _style: {fontWeight: 'bold'},
      className: 'text-[#3B82F6] mt-6',
      sorter: true,
    },
    {
      key: 'obatindikasi',
      label: 'Indikasi',
      _style: {fontWeight: 'bold'},
      className: 'text-[#3B82F6] mt-6',
      sorter: true,
    },
    {
      key: 'obatkontraindikasi',
      label: 'Kontra Indikasi',
      _style: {fontWeight: 'bold'},
      className: 'text-[#3B82F6] mt-6',
      sorter: true,
    },
    {
      key: 'obatstatus',
      type: 'map',
      mapValue: {1: 'Aktif', 2: 'Non Aktif'},
      label: 'Status',
      _style: {fontWeight: 'bold'},
      className: 'text-[#3B82F6] pb-2 border-blue-500 border-b-2',
      sorter: false,
      filterType: 'select',
      filterValue: [
        {value: 1, text: 'Aktif'},
        {value: 2, text: 'Non Aktif'},
      ],
      // containerClassName: '',
    },
  ]

  constructor(props) {
    super(props)

    const {searchParams} = props
    this.state = {
      prevItem: {},
      tambah: false,
      ubah: false,
      limit: 10, // Limit data per page
      data: [],
      itemsCount: 0,
      uid: searchParams.get('dctid'),
      fetchingMore: false,
      gettingInitialData: true,
      hasMoreItems: true,
      device: 'mobile', // Bisa Web (Tabel) / Mobile (List)
      cari: '', // Value pencarian user
      obatid: 0,

      // Filter untuk pencarian web
      sort: '',
      activePage: 1,

      obatkode: '',
      obatnama: '',
      obatstatus: 1,
      obatkandungan: '',
      obatindikasi: '',
      obatkontraindikasi: '',
      obatperhatian: '',
    }
  }

  componentDidMount() {
    this.detectDevice()
  }

  detectDevice = () => {
    let isMobile =
      /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
        navigator.userAgent
      )

    this.setState({device: isMobile ? 'mobile' : 'web'}, this.getInitialData)
  }

  getInitialData = (additionalParams = {}) => {
    const {
      obatstatus,
      obatnama,
      sort,
      obatkode,
      obatkandungan,
      obatindikasi,
      obatkontraindikasi,
      obatperhatian,
    } = this.state
    let limit = 10
    this.setState({gettingInitialData: true})

    let params = {
      a: 'dk13',
      reg: 'dbdok',
      uid: this.state.uid,
      obatstatus,
      device: this.state.device,
      limit,
    }

    if (this.state.device === 'web') {
      let offset = (this.state.activePage - 1) * limit
      params = {
        ...params,
        offset,
        obatkode,
        obatnama,
        obatstatus,
        obatkandungan,
        obatindikasi,
        obatkontraindikasi,
        obatperhatian,
        sort,
        ...additionalParams,
      }
    } else {
      params = {
        ...params,
        obatnama: this.state.cari,
        offset: 0,
        ...additionalParams,
      }
    }

    axios
      .post(
        process.env.REACT_APP_BASE_URL_DOKTER + '/prd-data-obat/index',
        QueryString.stringify(params)
      )
      .then(({data: res}) => {
        this.setState({data: res})

        if (res.length < 10) {
          this.setState({hasMoreItems: false})
        } else {
          this.setState({hasMoreItems: true})
        }
      })
      .catch(err => {
        console.error('Error get Data Obat', err.message)
      })
      .finally(() => {
        this.setState({gettingInitialData: false})
      })

    axios
      .post(
        process.env.REACT_APP_BASE_URL_DOKTER + '/prd-data-obat/index-count',
        QueryString.stringify(params)
      )
      .then(({data: res}) => {
        this.setState({itemsCount: res[0]['total']})
      })
      .catch(err => {})
  }

  refreshAfterActivateOrDelete = () => {
    if (this.state.device === 'web') {
      this.setState({activePage: 1}, this.getInitialData)
    } else {
      this.getInitialData()
    }
  }

  refreshPage = () => {
    // Reset filter, sorting & paging
    // Filter untuk pencarian web
    const defData = {
      sort: 'obatnama ASC',
      activePage: 1,
      obatnama: '',
      obatkode: '',
      obatstatus: 1,
    }
    this.setState(defData)
    this.getInitialData(defData)
  }

  aktifkan = async item => {
    try {
      await axios.post(
        process.env.REACT_APP_BASE_URL_DOKTER + '/prd-data-obat/status',
        QueryString.stringify({
          a: 'dk13',
          uid: item.uid,
          reg: 'dbdok',
          obatid: item.obatid,
          status: 1,
        })
      )

      this.refreshAfterActivateOrDelete()
    } catch (error) {
      return this.alert.show({
        message: 'Terjadi kesalahan saat nonaktifkan data Satuan. [BP-01]',
      })
    }
  }

  hapus = async item => {
    try {
      await axios.post(
        process.env.REACT_APP_BASE_URL_DOKTER + '/prd-data-obat/status',
        QueryString.stringify({
          a: 'dk13',
          uid: item.uid,
          reg: 'dbdok',
          obatid: item.obatid,
          status: 2,
        })
      )

      this.refreshAfterActivateOrDelete()
    } catch (error) {
      return this.alert.show({
        message: 'Terjadi kesalahan saat nonaktifkan data Satuan. [BP-01]',
      })
    }
  }

  fetchMore = () => {
    const {data, cari} = this.state
    this.setState({fetchingMore: true})
    axios
      .post(
        process.env.REACT_APP_BASE_URL_DOKTER + '/prd-data-obat/index',
        QueryString.stringify({
          a: 'dk13',
          reg: 'dbdok',
          uid: this.state.uid,
          offset: data.length,
          obatstatus: this.state.obatstatus,
          obatnama: cari,
          obatkode: cari,
        })
      )
      .then(({data: res}) => {
        if (res.length < 10) {
          this.setState({hasMoreItems: false})
        }
        this.setState({data: [...data, ...res]})
      })
      .catch(err => {
        console.error('Error get Data Racikan', err.message)
      })
      .finally(() => {
        this.setState({fetchingMore: false})
      })
  }

  cari = () => {
    const {cari} = this.state
    axios
      .post(
        process.env.REACT_APP_BASE_URL_DOKTER + '/prd-data-obat/index',
        QueryString.stringify({
          a: 'dk13',
          reg: 'dbdok',
          uid: this.state.uid,
          obatnama: cari,
          obatkode: cari,
        })
      )
      .then(({data: res}) => {
        this.setState({data: res})

        if (res.length < 10) {
          this.setState({hasMoreItems: false})
        }
      })
      .catch(err => {
        console.error('Error get Data Racikan', err.message)
      })
  }

  render() {
    const {
      data,
      hasMoreItems,
      device,
      tambah,
      ubah,
      obatstatus,
      itemsCount,
      uid,
      prevItem,
    } = this.state

    return (
      <VmView
        className=""
        // style={{fontFamily: ''}}
      >
        <AlertOk refs={ref => (this.alert = ref)} />
        <AlertYesNo ref={ref => (this.prompt = ref)} />

        {/* Component untuk navigasi */}
        {tambah ? (
          <Navigate to={`/prd-data-obat/update?dctid=${uid}`} replace={true} />
        ) : null}

        {/* Component untuk navigasi */}
        {ubah ? (
          <Navigate
            to={`/prd-data-obat/update?dctid=${uid}&obatid=${this.state.obatid}`}
            replace={true}
            state={{item: prevItem}}
          />
        ) : null}

        {/* <p>{this.state.device}</p> */}

        <VmIndexRead
          headerTitle={'Data Obat'}
          items={data}
          itemsCount={itemsCount}
          fields={device === 'mobile' ? this.fields : this.fieldsDesktop}
          listItemContainerClassName={'p-4 border shadow-lg m-4 rounded'}
          listSearchbar={{placeholder: 'Cari Data Obat'}}
          // listSearchbarLeft={<p>Test halo</p>}
          listSearchbarRight={
            <VmPicker
              style={{
                // flex: 0.2,
                background:
                  'url(https://cdn-icons-png.flaticon.com/512/32/32195.png) var(--sizeIco) no-repeat #FFF',
                paddingRight: '4px !important',
                paddingLeft: '4px',
              }}
              items={[
                {value: 1, text: 'Aktif'},
                {value: 2, text: 'Non Aktif'},
              ]}
              onChange={e => {
                let val = e.target.value
                this.setState({obatstatus: val}, this.getInitialData)
              }}
              placeholder={null}
              value={obatstatus}
              className="rounded-xl text-sm mb-2 py-2"
            />
          }
          listSearchbarClassname="mr-2" // Class Untuk inputan filter search bar
          onItemPress={item => {}}
          editButton={item => {
            return parseInt(item.obatstatus) === 1
          }}
          deleteButton={item => {
            return parseInt(item.obatstatus) === 1
          }}
          customButton={item => {
            if (parseInt(item.obatstatus) === 1) return
            return (
              <div
                onClick={() => {
                  this.aktifkan({...item, uid})
                }}
                className="flex flex-1 items-center justify-center rounded bg-green-500 ml-2 py-1"
              >
                <VmCheckIcon
                  color="white"
                  height={`${24}px`}
                  width={`${24}px`}
                />
                <p className="text-white">Aktifkan</p>
              </div>
            )
          }}
          onEditItemPress={item => {
            this.setState({obatid: item.obatid, ubah: true, prevItem: item})
          }}
          onDeleteItemPress={item => {
            this.prompt.show(
              {message: `Apakah anda yakin ingin menghapus ${item.obatnama}?`},
              () => {
                this.hapus({...item, uid})
              }
            )
          }}
          // Start List Props
          hasMoreItems={hasMoreItems}
          loadMore={() => {
            // Jika sedang load new data / get Initial data maka ndak perlu panggil fetchMore lagi (Antisipasi data ndobel)
            if (!this.state.fetchingMore && !this.state.gettingInitialData)
              this.fetchMore()
          }}
          onFabPress={() => {
            this.setState({isModalOpen: true})
          }}
          device={device}
          onSearchSubmit={value => {
            this.setState({cari: value}, this.getInitialData)
          }}
          loadingFetchData={this.state.gettingInitialData}
          totalPage={Math.ceil(this.state.itemsCount / 10)}
          activePage={this.state.activePage}
          onActivePageChange={page => {
            this.setState({activePage: page}, this.getInitialData)
          }}
          onColumnFilterChange={data => {
            let prevFilter = {
              obatkode: this.state.obatkode,
              obatnama: this.state.obatnama,
              obatstatus: this.state.obatstatus,
              obatkanungan: this.state.obatkandungan,
              obatindikasi: this.state.obatindikasi,
              obatkontraindikasi: this.state.obatkontraindikasi,
              obatperhatian: this.state.obatperhatian,
            }
            if (JSON.stringify(data) !== JSON.stringify(prevFilter)) {
              // Search hanya jika value filter kolom ada yang berubah
              this.setState({...data, activePage: 1}, this.getInitialData)
            }
          }}
          onSorterValueChange={sortData => {
            this.setState(
              {sort: `${sortData.column} ${sortData.asc ? 'asc' : 'desc'}`},
              this.getInitialData
            )
          }}
          totalCount={this.state.itemsCount}
          title="Data Obat"
          onRefreshPress={this.refreshPage}
          columnFilterValue={{
            obatnama: '',
            obatstatus: 1,
            obatkode: '',
          }}
          sorterValue={{column: 'obatnama', asc: true}}
          statusColName="obatstatus"
          onActivate={item => this.aktifkan({...item, uid})}
        />

        <ModalTambahObatKFA
          isOpen={this.state.isModalOpen}
          onClose={() => {
            this.setState({isModalOpen: false})
          }}
          kl_id={uid}
          refetchData={this.refreshPage}
        />
      </VmView>
    )
  }
}

export default function PrdDataObat(props) {
  const [searchParams] = useSearchParams()

  return <Page {...props} searchParams={searchParams} />
}
